import React, { createContext, useContext, useState, useEffect } from "react";
import { API_ENDPOINTS } from "../config/api";
import axios from "axios";

const AppSettingsContext = createContext({
  deliveryConditions: "",
});

export const AppSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    deliveryConditions: "",
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(API_ENDPOINTS.GET_APPLICATION_SETTINGS);
      
        if (response.data.success) {
          const data = response.data.data;
          
          const newSettings = {
            deliveryConditions: data["delivery-conditions"] || "",
            deliveryDate: data["delivery-date"] || "",
            appLogo: data["logo"] || "/images/logo.svg"
          };
          
          setSettings(newSettings);
        } else {
          console.error("API response indicates failure:", response.data);
        }
      } catch (error) {
        console.error("Error fetching application settings:", error);
      }
    };

    fetchSettings();
  }, []);

  // Log whenever settings change
  useEffect(() => {
    console.log("Current settings state:", settings);
  }, [settings]);

  return (
    <AppSettingsContext.Provider value={settings}>
      {children}
    </AppSettingsContext.Provider>
  );
};

export const useAppSettings = () => {
  const context = useContext(AppSettingsContext);
  if (context === undefined) {
    throw new Error('useAppSettings must be used within an AppSettingsProvider');
  }
  return context;
};
